import { Component, JSX, h, Host, getAssetPath, ComponentInterface } from '@stencil/core';

@Component({
  tag: 'nbn-features-highlight',
  styleUrl: 'nbn-features-highlight.scss'
})
export class NbnFeaturesHighlight implements ComponentInterface {
  public render(): JSX.Element {
    return (
      <Host>
        <div class="container">
          <div class="row content">
            <div class="col-sm-12 col-md-4 item">
              <agl-ds-feature-card icon-path={getAssetPath('../assets/icon/agl_icon_dig_unlimited.svg')}>
                <span slot="title">
                  <agl-ds-h3 styled-as="title6" suppress-margin="true">
                    Unlimited data
                  </agl-ds-h3>
                </span>
                <span slot="description">
                  <agl-ds-p font="fontfamily02" styled-as="sm" suppress-margin="true">
                    <agl-ds-text>Browse with peace of mind – and no excess data charges</agl-ds-text>
                  </agl-ds-p>
                </span>
              </agl-ds-feature-card>
            </div>
            <div class="col-sm-12 col-md-4 item">
              <agl-ds-feature-card icon-path={getAssetPath('../assets/icon/agl_icon_dig_onlinebonus.svg')}>
                <span slot="title">
                  <agl-ds-h3 styled-as="title6" suppress-margin="true">
                    Easy setup
                  </agl-ds-h3>
                </span>
                <span slot="description">
                  <agl-ds-p font="fontfamily02" styled-as="sm" suppress-margin="true">
                    <agl-ds-text>With no AGL setup fees</agl-ds-text>
                  </agl-ds-p>
                </span>
              </agl-ds-feature-card>
            </div>
            <div class="col-sm-12 col-md-4 item">
              <agl-ds-feature-card icon-path={getAssetPath('../assets/icon/agl_icon_dig_nolockin.svg')}>
                <span slot="title">
                  <agl-ds-h6 styled-as="title6" suppress-margin="true">
                    No lock-in contracts
                  </agl-ds-h6>
                </span>
                <span slot="description">
                  <agl-ds-p font="fontfamily02" styled-as="sm" suppress-margin="true">
                    <agl-ds-text>You have the flexibility to change your plan once a month, with our month-to-month plans</agl-ds-text>
                  </agl-ds-p>
                </span>
              </agl-ds-feature-card>
            </div>
          </div>
        </div>
      </Host>
    );
  }
}
